import getWeatherOption from '../data/store/store';
import initiateWeatherPullTaskOnCalendar from '../data/actions/initiateWeatherPullTaskOnCalendar';
import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';
import WeatherOptionState from '../data/store/schema/WeatherOptionState';
import { action } from 'satcheljs/lib/legacy';
import { getFallbackValueIfNull, updateUserOptions } from 'owa-options-core';
import {
    getCalendarConfiguration,
    saveCalendarMailboxConfiguration,
    updateCalendarMailboxConfiguration,
} from 'owa-calendar-configuration';

export default action('saveWeatherOption')(async function saveWeatherOption() {
    const optionState: WeatherOptionState = getWeatherOption();
    const calendarConfiguration: MailboxCalendarConfiguration = getCalendarConfiguration();

    let newWeatherEnableStatus = getFallbackValueIfNull(
        optionState.weatherEnabled,
        calendarConfiguration.WeatherEnabled
    );

    let newWeatherUnitSelected = getFallbackValueIfNull(
        optionState.weatherUnit,
        calendarConfiguration.WeatherUnit
    );

    let newWeatherLocations = getFallbackValueIfNull(
        optionState.weatherLocations,
        calendarConfiguration.WeatherLocations
    );

    const partialCalendarMailboxConfiguration = {
        WeatherEnabled: newWeatherEnableStatus,
        WeatherUnit: newWeatherUnitSelected,
        WeatherLocations: newWeatherLocations,
    };

    // update the UserOptions so that changes reflect in current session
    updateUserOptions(partialCalendarMailboxConfiguration);

    updateCalendarMailboxConfiguration(partialCalendarMailboxConfiguration);

    /**
     *  This action has been called to notify calendar
     *  that save is initiated in settings and run weatherPull task
     *  in calendar to update weather on calendar surface
     */
    initiateWeatherPullTaskOnCalendar();

    // save the new calendar configuration at server
    await saveCalendarMailboxConfiguration(partialCalendarMailboxConfiguration);
});
